import { AutogenModelRapidAlertMsg, AutogenRowRapidAlertMsg } from "./autogen/AutogenModelRapidAlertMsg";

export class ModelRapidAlertMsg extends AutogenModelRapidAlertMsg<RowRapidAlertMsg> {
	constructor() {
		super(RowRapidAlertMsg);
	}
}

export class RowRapidAlertMsg extends AutogenRowRapidAlertMsg {
}